<template>
  <div>
    <nav class="bar bar-nav">
      <h1 class="title">申请信用支付</h1>
    </nav>
    <div class="content">
      <div class="list-block media-list" style="margin-top: 0px;">
        <ul>
          <li >
            <div>
              <div class="item-inner" style="padding-left: 0.75rem;">
                <div>
                  <div class="item-title tip">请上传名片正面或身份证正反面</div>
                  <div class="item id-card">
                    <div class="show-image">
                      <span class="add-card" v-if="avatarPositive===''">+添加正面</span>
                      <img v-else :src="avatarPositive" style="height: 146px;width: 100%;">
                    </div>
                    <input type="file" name="positive" class="input" accept="image/jpg,image/jpeg,image/png"
                           @change="changeImagePositive($event)" ref="avatarInputPosi">
                  </div>
                  <div class="item id-card">
                    <div class="show-image">
                      <span class="add-card" v-if="avatarNegative===''">+添加反面</span>
                      <img v-else :src="avatarNegative" style="height: 146px;width: 100%;">
                    </div>
                    <input type="file" name="negative" class="input" accept="image/jpg,image/jpeg,image.png"
                           @change="changeImageNegative($event)" ref="avatarInputNega">
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li >
            <div class="item-content">
              <div class="item-inner">
                <div>
                  <div class="item">
                    <p class="tip">注：</p>
                    <div class="id-p"><p>1.请上传清晰的名片正面或身份证正面及反面。</p></div>
                    <div class="id-p"><p>2.照片大小不超过5MB，支持照片格式jpg，jpeg，png。</p></div>
                    <div class="id-p"><p>3.吉凯基因淘基因向您承诺：您的身份证信息仅用作申请信用付款验证，我们绝不外漏！</p></div>
                    <div class="id-p"><p style="margin-top: -0.3rem;">4.在您提交认证申请后，我们将在两个工作日内完成审核，审核成功后，根据具体情况，您可以获得
                      <strong style="color:#f6383a">10000元</strong>或<strong style="color:#f6383a">50000元</strong>的信用额度。请您在"个人中心-我的信用"中查看您的信用额度。</p></div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="content-block">
        <a :href="href" class="button button-big button-fill button-danger external" :disabled="disable" :class="{'disabled': disable}" @click="uploadImage">提交</a>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState, mapMutations} from 'vuex'
  import $ from 'jquery'

  export default {
    created () {
    },
    mounted () {
    },
    data () {
      return {
        avatarPositive: '',
        avatarNegative: '',
        disable: false,
        href: 'javascript:;'
      }
    },
    computed: {
      ...mapState([
        'sessionInfo'
      ])
    },
    watch: {
    },
    methods: {
      ...mapMutations([
        'CLIENT_INFO'
      ]),
      changeImagePositive (e) {
        let file = e.target.files[0]
        let isAllowedUpdate = this.checkImage(file)
        if (!isAllowedUpdate) {
          $.toast('上传图片过大')
          return
        }
        let reader = new FileReader()
        let _this = this
        reader.readAsDataURL(file)
        reader.onload = function (e) {
          _this.avatarPositive = this.result
        }
      },
      changeImageNegative (e) {
        let file = e.target.files[0]
        let isAllowedUpdate = this.checkImage(file)
        if (!isAllowedUpdate) {
          $.toast('上传图片过大')
          return
        }
        let reader = new FileReader()
        let _this = this
        reader.readAsDataURL(file)
        reader.onload = function (e) {
          _this.avatarNegative = this.result
        }
      },
      checkImage (file) {
        let maxSize = 5000 // 5mb
        let size = file.size
        let isAllow = false
        maxSize = maxSize * 1024 // 转化为字节数
        isAllow = size <= maxSize
        return isAllow
      },
      uploadImage () {
        if (this.disable === true) {
          $.toast('请勿重复提交')
          return
        } else {
          $.showPreloader('上传中')
          setTimeout(function () {
            $.hidePreloader()
          }, 5000)
        }
        let posiImage = this.$refs.avatarInputPosi.files
        let negaImage = this.$refs.avatarInputNega.files
        if (posiImage.length !== 0 || negaImage.length !== 0) {
          this.disable = true
          let image = new FormData()
          image.append('positive', posiImage[0])
          image.append('negative', negaImage[0])
          let config = {
            'Content-Type': 'multipart/form-data'
          }
          let _this = this
          this.$http.post('/gcapi/gcwwwifc/applyCreditPay', image, config).then((res) => {
            if (res.body.code === 0) {
              $.toast('上传成功')
              _this.href = 'javascript:window.history.back()'
              _this.gcapi('gcwwwifc/getCustomerInfo').then((response) => {
                _this.CLIENT_INFO(response.body.result)
              })
            } else {
              this.disable = false
              $.toast(res.message)
            }
          })
        } else {
          $.toast('请上传清晰的名片正面或身份证正面及反面')
        }
      },
      goBack () {
        this.$router.go(-1)
      }
    },
    filters: {
      currencyStyle (val) {
        return ' ¥ ' + val
      }
    }
  }

</script>

<style scoped>
  .tip {
    font-size: 0.7rem;
    height: 1.5rem;
  }
  .id-card {
    height: 150px;
    width: 80%;
    margin-left: 10%;border: 2px solid #EFEFEF;
    text-align: center;
    margin-bottom:5px;
  }
  .input {
    display: block;
    /*position: absolute;*/
    opacity: 0;
    top: 2.35px;
    left: 0;
    height: 146px;
    width: 100%;
  @include wh(100%,3.1px);
  }
  .add-card {
     /* placeholder颜色  */
     color: #aab2bd;
     /* placeholder字体大小  */
     font-size: 13px;
     /* placeholder位置  */
     text-align: center;
    line-height: 150px;
  }
  .id-p{
    font-size: 0.6rem;
    margin-top: -0.1rem;
  }
  .show-image{
    position: absolute;
    width:73.5%;

  }
</style>



// WEBPACK FOOTER //
// ApplyCreditPay.vue?31b1af0c